import { gql } from '@apollo/client'

export const CATEGORIES = gql`
  fragment CategoriesFragment on Category {
    id
    name
    externalReference
  }
`
